import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography
} from "@mui/material";
import { useState } from "react";

const AadhaarModal = ({ open, onClose, onSubmit, loading }) => {
  const [aadhaar, setAadhaar] = useState("");

  const handleSubmit = () => {
    if (aadhaar.length !== 12) return;
    onSubmit(aadhaar);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Enter Aadhaar Number</DialogTitle>

      <DialogContent>
        {/* Label Outside */}
        <Typography sx={{ fontSize: 14, fontWeight: 500, mb: 0.5 }}>
          Aadhaar Number <span style={{ color: "red" }}>*</span>
        </Typography>

 <TextField
  fullWidth

  value={aadhaar}
  placeholder="Enter 12 digit Aadhaar"
  inputProps={{
    maxLength: 12,
    inputMode: "numeric", // mobile numeric keyboard
    pattern: "[0-9]*"
  }}

  required
  onChange={(e) =>
    setAadhaar(e.target.value.replace(/[^0-9]/g, ""))
  }
 
/>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={aadhaar.length !== 12 || loading}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AadhaarModal;